import audio1 from 'assets/sounds/nn/diktat/sild.mp3';//1
import audio2 from 'assets/sounds/nn/diktat/2-aldri.mp3';//2
import audio3 from 'assets/sounds/nn/diktat/skjelven.mp3';//3
import audio4 from 'assets/sounds/nn/diktat/godt.mp3';//4
import audio5 from 'assets/sounds/nn/diktat/kyllinger.mp3';//5
import audio6 from 'assets/sounds/nn/diktat/kjøt.mp3';//6
import audio7 from 'assets/sounds/nn/diktat/7-nklane.mp3';
import audio8 from 'assets/sounds/nn/diktat/8-skjnte.mp3';
import audio9 from 'assets/sounds/nn/diktat/9-gjerne.mp3';
import audio10 from 'assets/sounds/nn/diktat/lov.mp3';//10
import audio11 from 'assets/sounds/nn/diktat/enn.mp3';//11
import audio12 from 'assets/sounds/nn/diktat/fugl.mp3';//12
import audio13 from 'assets/sounds/nn/diktat/13-vill.mp3';
import audio14 from 'assets/sounds/nn/diktat/sykkelhjelm.mp3';//14
import audio15 from 'assets/sounds/nn/diktat/15-farleg.mp3';
import audio16 from 'assets/sounds/nn/diktat/16-hjerne.mp3';
import audio17 from 'assets/sounds/nn/diktat/17-skall.mp3';
import audio18 from 'assets/sounds/nn/diktat/18-gips.mp3';
import audio19 from 'assets/sounds/nn/diktat/sannsyn.mp3';//19
import audio20 from 'assets/sounds/nn/diktat/abrakadabra.mp3';//20
import audio21 from 'assets/sounds/nn/diktat/21-unnskyld.mp3';
import audio22 from 'assets/sounds/nn/diktat/kroppstemperatur.mp3';//22
import audio23 from 'assets/sounds/nn/diktat/reportasje.mp3';//23
import audio24 from 'assets/sounds/nn/diktat/24-skylder.mp3';
import audio25 from 'assets/sounds/nn/diktat/25-utakksam.mp3';


const audioFiles = {
	1: audio1,
	2: audio2,
	3: audio3,
	4: audio4,
	5: audio5,
	6: audio6,
	7: audio7,
	8: audio8,
	9: audio9,
	10: audio10,
	11: audio11,
	12: audio12,
	13: audio13,
	14: audio14,
	15: audio15,
	16: audio16,
	17: audio17,
	18: audio18,
	19: audio19,
	20: audio20,
	21: audio21,
	22: audio22,
	23: audio23,
	24: audio24,
	25: audio25,
};

export default audioFiles;
